// modules
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { Gender, Location } from '@weblite/sahab-profile-action/profile'
// component
import { SelectMenuDrawer } from '$common/select-menu'
import { LocationIcon } from '$common/icons/location'
import { t } from '$i18n'
import { PersonIcon } from '$common/icons/person'
import { getCounty, PROVINCES } from './select-county'

const COMPONENT_ID = 'selectMenu'

const showSelectMenu = (props: Parameters<typeof SelectMenuDrawer>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showSelectCounty = (onSelect: (location: Location) => unknown) =>
  showSelectMenu({
    onClose: closeCurrentModal,
    headerTexts: [
      t('selectMenu.county.selectProvince'),
      t('selectMenu.county.selectCounty'),
    ],
    alignOptionsCenter: false,
    HeaderIcon: LocationIcon,
    optionFetchers: [
      async () => PROVINCES,
      ([province]) => getCounty(province),
    ],
    onDone: (selectedOptions: string[]) => {
      const province = selectedOptions[0]
      const county = selectedOptions[1]
      onSelect({ county, province })
      closeCurrentModal()
    },
  })

export const showSelectGender = (onSelect: (gender: Gender) => unknown) =>
  showSelectMenu({
    onClose: closeCurrentModal,
    headerTexts: [t('selectMenu.gender.selectGender')],
    alignOptionsCenter: false,
    optionFetchers: [async () => [t('common.male'), t('common.female')]],
    onDone: (selectedOptions: string[]) => {
      const value = selectedOptions[0]
      onSelect(
        value === t('common.male')
          ? Gender.MALE
          : value === t('common.female')
            ? Gender.FEMALE
            : null,
      )
      closeCurrentModal()
    },
    HeaderIcon: PersonIcon,
  })

export default {
  [COMPONENT_ID]: {
    Component: SelectMenuDrawer,
  },
}
